<template>
    <div class="item_list" :class="{ android: android }">
        <title-bar :title="teamName">
            <router-link :to="{ name: 'info' }" slot="left" class="user_info_icon">
                <img class="logo_icon" :src="avatar && avatar !== 'null' ? avatar : defaultAvatar" />
            </router-link>
            <div class="select-group" slot="right">
                <router-link :to="{ name: 'team' }" class="group-menu">
                    <img src="@/assets/imgs/group_menu.svg" />
                </router-link>
            </div>
        </title-bar>
        <project-selector
            class="project-selector"
            pluginType="xd"
            :unshiftCurrentFolder="{}"
            @select="selectItem"
            ref="projectSelector"
        ></project-selector>
    </div>
</template>

<script>
import titleBar from "@/components/layout/TitleBar"
import projectSelector from "lanhu-features/src/features/ProjectSelector/project-selector.vue"
import { slice } from "lodash-es"
export default {
    name: "itemList",
    components: {
        titleBar,
        projectSelector
    },
    data() {
        return {
            list: [],
            typeStr: {
                mobile: "手机APP",
                web: "网页web"
            },
            warn: false
        }
    },
    computed: {
        teamName() {
            return localStorage.teamName
        },
        defaultAvatar() {
            return require("../../assets/imgs/logo_icon.png")
        },
        android() {
            return window.system === "android"
        },
        avatar() {
            if (localStorage.itemPageAvatar) {
                return localStorage.avatar
            } else {
                return false
            }
        }
    },
    created() {
        lanhuAPI.apiStorage.activeTeamId = localStorage.teamId
        lanhuAPI.apiStorage.activeUserId = localStorage.userId
    },
    async mounted() {
        await this.$refs["projectSelector"].getProjectFolder(localStorage.teamId)
        if (this.$route.query.type === "search") {
            this.$refs["projectSelector"].toggleSearch()
        }
    },
    methods: {
        selectItem(selected) {
            let path = selected.path
            let item = path[path.length - 1]
            if (item.type == "project") {
                this.goToItem(item.id)
            }
        },
        goToItem(project_id) {
            this.$router.push({
                name: "item",
                query: {
                    project_id: project_id
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.item_list {
    &.android {
        padding-top: 3.45rem !important;
    }
    height: 100%;
    padding-top: 3.35rem; //ios_top
    padding-top: calc(constant(safe-area-inset-top) + 2.35rem);
    padding-top: calc(env(safe-area-inset-top) + 2.35rem);
    overflow: hidden;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    .project-selector {
        width: 100% !important;
        height: 100% !important;
    }
    .select-group {
        top: 0.1rem;
        position: relative;
        .group-menu {
            vertical-align: middle;
            width: 1.15rem;
            display: inline-block;
            color: #5b606a;
            opacity: 0.7;
        }
        img {
            width: 100%;
        }
    }
    .user_info_icon {
        height: 100%;
        position: relative;
        display: block;
        .logo_icon {
            border-radius: 50%;
            width: 1.5rem;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translate(0, -50%);
        }
    }
}
</style>
